export class Document {
    category: string;
    carrier: string;
    linkText: string;
    linkUrl: string;
    windowHeight: number;
    windowWidth: number;
    fileType: string;

    constructor() {
        this.category = null;
        this.carrier = null;
        this.linkText = null;
        this.linkUrl = null;
        this.windowHeight = 0;
        this.windowWidth = 0;
        this.fileType = null;
    }
}

export class DocumentPayload {
    memberID: number;
    dependentID: number;
    qleRequestID: number;
    qualifyingEventType?: string;
    files: File[];

    constructor() {
        this.memberID = 0;
        this.dependentID = 0;
        this.qleRequestID = 0;
        this.qualifyingEventType = null;
        this.files = null;
    }
}

export class FileUploadResponse {
    completedUploadCount: number;
    failedUploadCount: number;

    constructor() {
        this.completedUploadCount = 0;
        this.failedUploadCount = 0;
    }
}

export class QLEDocument {
    id: number;
    documentName: string;
    isUploadFailure: boolean;
    errorMessage: string;

    constructor() {
        this.id = 0;
        this.documentName = '';
        this.isUploadFailure = false;
        this.errorMessage = '';
    }
}

export class DocumentStatus {
    documentName: string;
    receivedDate: string;
    reviewedDate: string;
    status: string;
}